<div class="schedule-navbar">
    <div>
        <button (click)="prev()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-left"></mat-icon>
        </button>
    </div>
    <div class="content">
        <p class="large">
            @for (realisation of realisations; track realisation; let last = $last) {
                {{
                    realisation.planning?.afas_project_id ??
                        realisation.project?.afas_project_id ??
                        realisation.afas_project_id
                }}
                {{ last ? '' : ' / ' }}
            }
            @for (realisation of notWorkRealisations; track realisation; let last = $last) {
                {{ realisation.hourtype | hourtype }} {{ last ? '' : ' / ' }}
            }
            @if (!realisations?.length && !notWorkRealisations?.length) {
                niet ingepland
            }
        </p>
        <p class="small">{{ date | date: 'EEEE d MMMM yyyy' }}</p>
    </div>
    <div>
        <button [disabled]="nextDate >= maxDate" (click)="next()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-right"></mat-icon>
        </button>
    </div>
</div>
<div class="content details">
    @if (!realisations?.length && !notWorkRealisations?.length) {
        <div class="head section bg-white">
            <div class="container-xl">
                <h1>
                    {{ date > maxDate ? 'nog niet beschikbaar' : 'niet ingepland' }}
                </h1>
                <div class="data">
                    <div class="data-row">
                        <div class="data-cell">Datum</div>
                        <div class="data-cell strong">{{ date | date: 'd MMMM yyyy' }}</div>
                    </div>
                </div>
            </div>
        </div>
    }
    @for (realisation of notWorkRealisations; track realisation; let index = $index) {
        @let sameHourtype = (notWorkRealisations[index - 1]?.hourtype | hourtype) === (realisation.hourtype | hourtype);
        <div class="head section bg-white" [class.pt-0]="sameHourtype">
            <div class="container-xl">
                @if (!sameHourtype) {
                    <h2 class="mb-0">
                        {{ realisation.hourtype | hourtype }}
                    </h2>
                }
                <div class="data">
                    <div class="data-row">
                        <div class="data-cell">Tijd</div>
                        <div class="data-cell strong">
                            {{ realisation.begindate | date: 'EE HH:mm' }} -
                            {{ realisation.enddate | date: 'EE HH:mm' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    @for (realisation of realisations; track realisation) {
        <app-realisation-detail [realisation]="realisation" />
    }
</div>
<div class="button-wrapper">
    <div class="container-xl">
        <div class="buttons">
            <button class="planning-button" (click)="back()" mat-raised-button color="primary">Terug</button>

            @if (date < maxDate && (Functionalities.Hours | hasFunctionality)) {
                <button
                    class="planning-button ms-2"
                    mat-raised-button
                    color="accent"
                    routerLink="/hours/{{ date | date: 'yyyy-MM-dd' }}">
                    Urenregistratie
                </button>
            }
        </div>
    </div>
</div>
